import {
  Component,
  EventEmitter,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Form } from '../../../../domain/form.interface';
import { Store, select } from '@ngrx/store';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ModalCssComponent } from '../modal-css/modal-css.component';
import { ModalHeaderComponent } from '../modal-header/modal-header.component';
import { slugAsyncValidator } from '../../../../infrastructure/libs/slug.validator';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AbstractControl } from '@angular/forms';
import { selectConfig } from '../../../../infrastructure/store/selectors/config.selector';
import { environment } from '../../../../../environments/environment';
// Actions
import {
  addForm,
  deleteForm,
  editForm,
  newForm,
  cloneForm
} from '../../../../infrastructure/store/actions/form.actions';
import { 
  setNewForm,
  setSelectedForm, 
  setCreateStatus as setCreateStatusForm, 
  setUpdateStatus as setUpdateStatusForm,
  setCloneStatus as setCloneStatusForm
} from '../../../../infrastructure/store/selectors/form.selector';
import { 
  addVersion, 
  deleteVersion,
  editVersion
 } from '../../../../infrastructure/store/actions/version.actions';
 import { 
  setSelectedVersion
 } from '../../../../infrastructure/store/selectors/version.selector';

 import { ConfirmationDialogData, ModalConfirmationComponent } from '../../../commons/modal-confirmation/modal-confirmation.component';

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss'],
})
export class GeneralComponent implements OnInit, OnChanges, OnDestroy {

  @Output() private edit= new EventEmitter<boolean>();

  elementSelected!: Form; // Element selected to toggle form-version

  forms: Form[] = []; // Forms lis
  formSelected!: Form; // Form selected
  versions: Form[] = [];
  versionSelected!: Form; // Version selected
  
  formGroup: FormGroup;
  defaultFormValues: any;
  submitted = false;
  isNewForm = false;
  editActive = false;
  color: string = '';
  defaultColor: string = '#ffffff';
  openPanel = true;
  unsubscribe$ = new Subject();
  fonts = [
    'Arial',
    'Verdana',
    'Tahoma',
    'Trebuchet MS',
    'Times New Roman',
    'Georgia',
    'Garamond',
    'Courier New',
    'Brush Script MT',
  ];
  defaultFont = 'Arial'

  apiMethods: string[] = ['GET', 'POST', 'PUT', 'DELETE']; // Add more methods as needed

  headersLayouts = [
    { key: 'layout_1', label: 'Image Left' },
    { key: 'layout_2', label: 'Image Right' }
  ];
  defaultHeader = 'layout_1'

  pdfEvents = [
    { value: 'save', label: 'Page Save' },
    { value: 'complete', label: 'Form Complete' },
    { value: 'note_created', label: 'Note Created' }
  ];

  webhookEvents: any[] = [   
    { id: 'complete', name: 'Complete' },
    { id: 'pdf', name: 'Generate PDF' }
  ];

  orderable_properties: Array<{
    key: string;
    label: string;
    order: number;
  }> = [
    { key: 'db', label: 'Database', order: 0 },
    { key: 'injection', label: 'WC Injection', order: 1 },
    { key: 'query', label: 'Query Params', order: 2 },
  ];

  formOptions = {}; // Fill web component input
  urlBackend: string = "";
  isPreview = false;

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
    ) {
    //this.color = this.defaultColor;
  }

  ngOnInit(): void {
    // Selectors
    this.store
      .pipe(select(setNewForm))
      .pipe(
        tap((isNewForm) => {
          this.isNewForm = isNewForm;
          if(isNewForm) {
            this.resetForm();
            this.setEdit(true);
          }        
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe();

    this.store.select(selectConfig).pipe(
      filter(x => x.data['FORM_API']),
      takeUntil(this.unsubscribe$)
    ).subscribe({
      next: (v) => {
        if (v) {
          this.urlBackend = v.data['FORM_API'];
        }
      },
      error: (e) => {
        console.log('ERROR->', <any>e);
      }
    });

    this.store
      .pipe(select(setSelectedForm))
      .pipe(
        //filter(x => x.status == "success"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {          
          this.formSelected = v;
          if(v) {
            this.elementSelected = v;
            this.initForm();
            this.setEdit(false);
          }         
        },
        error: (e) => {         
          console.log('ERROR->', <any>e);
        }
      });

    this.store
      .pipe(select(setSelectedVersion))
      .pipe(
        //filter(x => x.status == "success"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {
          this.versionSelected = v;
          if(v) {
            this.elementSelected = v;
            this.initForm();
            this.setEdit(false);
          }        
        },
        error: (e) => {         
          console.log('ERROR->', <any>e);
        }
      });

    this.store
      .pipe(select(setCreateStatusForm))
      .pipe(
        filter(x => x != "pending"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {          
          if(v == "success") {
            this.store.dispatch(newForm({ newForm: false }));
          }
        },
        error: (e) => {
          console.log('ERROR->', <any>e);
        }
    });

    this.store
      .pipe(select(setUpdateStatusForm))
      .pipe(
        filter(x => x != "pending"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {          
          if(v == "success") {
            this.store.dispatch(newForm({ newForm: false }));
          }
        },
        error: (e) => {
          console.log('ERROR->', <any>e);
        }
    });

    this.formGroup = this.formBuilder.group({
      name: ['', Validators.required],
      title: ['', Validators.required],
      description: [''],
      custom_key: ['', [Validators.required], slugAsyncValidator()],
      config: this.formBuilder.group({
        alert_message: [''],
        final_message: ['', [Validators.required]],
        final_message_hide: [''],
        header: [''],
        text_style: [this.defaultFont],
        header_layout: [this.defaultHeader],
        color: [this.color],
        advanced_css: [''],
        ignore_persistence: [''],
        submit_unlocked: [''],
        vocale: [''],       
        
        header_hide: [''],
        header_hide_title: [''],
        header_hide_image: [''],
        header_sticky: [''],

        footer_hide: [''],
        footer_save_hide: [''],
        footer_validate_hide: [''],
        footer_submit_hide: [''],
        footer_sticky: [''],

        save_text: [''],
        validate_text: [''],
        submit_text: [''],
        to_template_text: [''],
        notes_text: ['']

      }),
      template: this.formBuilder.group({
        email: [''],
        sms: [''],
        code: [''],
        pdf: ['']
      }),
      webhooks: this.formBuilder.array([]),
      pdf_events: this.formBuilder.array([]),
      orderable_properties: this.formBuilder.array([]),
    });

    this.defaultFormValues = this.formGroup.value;

    this.initForm();
  }

  get webhooks(): FormArray {
    return this.formGroup.get('webhooks') as FormArray;
  }

  get pdf_events(): FormArray {
    return this.formGroup.get('pdf_events') as FormArray;
  }

  get orderableProperties(): FormArray {
    return this.formGroup.get('orderable_properties') as FormArray;
  }

  initOrderableProperties() {
    const defaults = ['db', 'injection', 'query'];

    defaults.forEach((key, index) => {
      const labelObj = this.orderable_properties.find(prop => prop.key === key);
      this.orderableProperties.push(
        this.formBuilder.group({
          key: [key],
          label: [labelObj?.label || key],
          order: [index]
        })
      );
    });
  }

  onPdfEventChange(event) {

  }

  onWebhookEventChange(event) {

  }

  getWebhookEventNameById(eventId: string): string {
    const event = this.webhookEvents.find(e => e.id === eventId);
    return event ? event.name : eventId;
  }

  getPdfEventNameById(eventId: string): string {
    const event = this.pdfEvents.find(e => e.value === eventId);
    return event ? event.label : eventId;
  }

  addWebhook(webhook?) {
    const newWebhook = this.formBuilder.group({
      headers: [webhook?.headers || ''],
      label: [webhook?.label || ''],
      method: [webhook?.method || ''],
      url: [webhook?.url || ''],
      events: [webhook?.events || []]
      //events: this.createWebhookEventsFormArray(webhook?.events || [])
      //url: [webhook?.url || '', Validators.required]
    });
    console.log('WEBHOOK => ', newWebhook)
    this.webhooks.push(newWebhook);
  }

  createWebhookEventsFormArray(events: string[]): FormArray {
    console.log('createWebhookEventsFormArray');
    const formArray = this.formBuilder.array([]);
    this.webhookEvents.forEach(event => {
      console.log('EVENT => ', event)
      const control = new FormControl(true);
      //const control = this.formBuilder.control(events.includes(event.value));
      formArray.push(control);
    });
    console.log('formArray => ', formArray)
    return formArray;
  }

  removeWebhook(index: number) {
    this.webhooks.removeAt(index);
  }

  clearWebhooks() {
    const webhooksArray = this.formGroup.get('webhooks') as FormArray;
    while (webhooksArray.length !== 0) {
      webhooksArray.removeAt(0);
    }
  }

  clearPdfEvent() {
    const pdfEventsArray = this.formGroup.get('pdf_events') as FormArray;
    while (pdfEventsArray.length !== 0) {
      pdfEventsArray.removeAt(0);
    }
  }

  stringifyHeaders(headers: any): string {
    return headers ? JSON.stringify(headers, null, 2) : '';
  }

  stringToJson(jsonString: string): any {
    try {
      if (!jsonString) {
        //console.log('JSON String is empty or does not exist.');
        return {}; // Return an empty JSON object
      }
      const jsonObject = JSON.parse(jsonString);
      return jsonObject;
    } catch (error) {
      console.error('Error parsing JSON string:', error);
      return null;
    }
  }

  initForm() {
    this.isPreview = false;

    if (this.formGroup) {
      this.formGroup.patchValue(this.elementSelected);

      // 🔥 FIX: rebuild orderable properties
      this.resetOrderableProperties(this.elementSelected?.orderable_properties);

      this.clearWebhooks();
      this.clearPdfEvent();

      // PDF events
      this.pdfEvents.forEach((e) => {
        this.pdf_events.push(
          new FormControl(
            this.elementSelected?.pdf_events?.includes(e.value) ?? false
          )
        );
      });

      // Webhooks
      this.elementSelected?.webhooks?.forEach(webhook => {
        this.addWebhook(webhook);
      });
    }

    this.color = this.elementSelected?.config?.color || this.defaultColor;
  }

  resetForm() {
    this.isPreview = false;

    setTimeout(() => {
      if (this.formGroup) {
        this.color = this.defaultColor;
        this.formGroup.reset(this.defaultFormValues);

        this.resetOrderableProperties();
      }
    }, 60);
  }

  cancelEditForm() {
    this.store.dispatch(newForm({ newForm: false }));
    this.initForm();
    this.setEdit(false);
  }

  activeEditForm() {
    this.initForm();
    this.setEdit(true);
  }
  
  onPublish(): void {   
    const dialogData: ConfirmationDialogData = {
      messagePrimary: `When publishing a new version of a form, keep in mind that the links to enter data associated with the 'latest' version will reference the version you are publishing and the statistics and data will begin to be associated with this latest version from this moment on.`,
      messageSecondary: ``,
      icon: `rocket_launch`,
      confirmText: 'Publish',
      cancelText: 'Cancel',
      showCancel: true
    };

    const dialogRef = this.dialog.open(ModalConfirmationComponent, {
      height: '300px',
      width: '500px',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        // User clicked "Yes, Confirm"
        console.log('Confirmed!');
        this.store.dispatch(
          addVersion({formId: this.formSelected.sk})
        );
      } else {
        // User clicked "Cancel" or closed the dialog
        console.log('Canceled or closed');
      }
    });
  }

  onClone(): void {   
    const dialogData: ConfirmationDialogData = {
      messagePrimary: `When cloning a form all the fields and layout will be included in the new form, but the versions of the cloned form must be published manually.`,
      messageSecondary: ``,
      icon: `content_copy`,
      confirmText: 'Clone',
      cancelText: 'Cancel',
      showCancel: true
    };

    const dialogRef = this.dialog.open(ModalConfirmationComponent, {
      height: '300px',
      width: '500px',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        // User clicked "Yes, Confirm"
        console.log('Confirmed!');
        this.store.dispatch(
          cloneForm({form: this.formSelected})
        );
      } else {
        // User clicked "Cancel" or closed the dialog
        console.log('Canceled or closed');
      }
    });
  }

  deleteForm(): void {
    let elementTitle = 'Element'

    if(this.elementSelected.pk == 'form') {
      elementTitle = 'Form';
    }
    if(this.elementSelected.pk == 'version') {
      elementTitle = 'Version';
    }

    const dialogData: ConfirmationDialogData = {
      messagePrimary: `Do you really want to delete this ${elementTitle}? `,
      messageSecondary: `This process can not be undone.`,
      icon: `delete`,
      confirmText: 'Delete',
      cancelText: 'Cancel',
      showCancel: true
    };

    const dialogRef = this.dialog.open(ModalConfirmationComponent, {
      height: '250px',
      width: '500px',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        // User clicked "Yes, Confirm"
        console.log('Confirmed!');
        if(this.elementSelected.pk == 'form') {
          this.store.dispatch(deleteForm({ form: this.elementSelected }));
        }
        if(this.elementSelected.pk == 'version') {
          this.store.dispatch(deleteVersion({ formId: this.formSelected.sk, version: this.elementSelected }));
        }
      } else {
        // User clicked "Cancel" or closed the dialog
        console.log('Canceled or closed');
      }
    });
  }

  setEdit(edit: boolean) {
    this.editActive = edit;
    this.edit.emit(edit);
  }

  previewLayout() {
    console.log('Preview');
    this.formOptions = {
      formId: this.formSelected?.sk,
      versionId: this.elementSelected.pk == 'version' ? this.versionSelected?.sk : (this.versionSelected?.sk || 'latest'),
      page: 1,
      isPreview: !this.isPreview,
      urlBackend: this.urlBackend,
      urlBackendAccessControl: environment.accessControlAPI,
      form: {
        ...this.elementSelected
      }
    }
    this.isPreview = !this.isPreview;    
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.formGroup.invalid) {
        return;
    }

    const selectedPdfEventsIds = this.formGroup.value.pdf_events
    .map((checked, i) => checked ? this.pdfEvents[i].value : null)
    .filter(v => v !== null);
    console.log(selectedPdfEventsIds);

    this.formGroup.value.pdf_events = selectedPdfEventsIds;

    console.log('WEBHOOKS => ', this.formGroup.value.webhooks)

    if (this.isNewForm) {
      console.log('CONFIG -> ', this.formGroup.value.config)
      // Create form
      this.store.dispatch(
        addForm({          
          form: {
            name: this.formGroup.value.name,
            title: this.formGroup.value.title,
            description: this.formGroup.value.description,
            custom_key: this.formGroup.value.custom_key,
            fields: [],
            config: {
              text_style: this.formGroup.value.config.text_style,
              header_layout: this.formGroup.value.config.header_layout,
              advanced_css: this.formGroup.value.config.advanced_css,
              color: this.formGroup.value.config.color,
              header: this.formGroup.value.config.header,
              final_message: this.formGroup.value.config.final_message,
              final_message_hide: this.formGroup.value.config.final_message_hide,
              alert_message: this.formGroup.value.config.alert_message,
              
              header_hide: this.formGroup.value.config.header_hide,
              header_hide_title: this.formGroup.value.config.header_hide_title,
              header_hide_image: this.formGroup.value.config.header_hide_image,
              header_sticky: this.formGroup.value.config.header_sticky,

              footer_hide: this.formGroup.value.config.footer_hide,
              footer_save_hide: this.formGroup.value.config.footer_save_hide,
              footer_validate_hide: this.formGroup.value.config.footer_validate_hide,
              footer_submit_hide: this.formGroup.value.config.footer_submit_hide,
              footer_sticky: this.formGroup.value.config.footer_sticky,

              save_text: this.formGroup.value.config.save_text,
              validate_text: this.formGroup.value.config.validate_text,
              submit_text: this.formGroup.value.config.submit_text,
              to_template_text: this.formGroup.value.config.to_template_text,
              notes_text: this.formGroup.value.config.notes_text,

              ignore_persistence: this.formGroup.value.config.ignore_persistence,
              submit_unlocked: this.formGroup.value.config.submit_unlocked,
              vocale: this.formGroup.value.config.vocale
            },
            template: this.formGroup.value.template,
            webhooks: this.formGroup.value.webhooks,
            pdf_events: this.formGroup.value.pdf_events,
            orderable_properties: this.formGroup.value.orderable_properties,
            metadata: {
              origin: ''
            },
            status: '',          
            indexable_values: [],
            layout: []
          },
        })
      );
    } else {
        if(this.elementSelected.pk == 'form') {
          // Update form
          this.store.dispatch(
            editForm({
              form: {
                ...this.elementSelected,
                ...this.formGroup.value,
              },
            })
          );
        }
        if(this.elementSelected.pk == 'version') {
          // Update version
          this.store.dispatch(
            editVersion({
              formId: this.formSelected.sk,
              version: {
                ...this.elementSelected,
                ...this.formGroup.value,
              },
            })
          );
        }
    }
}

  colorPickerChange(color: string) {
    this.formGroup.get('config')['controls'].color.setValue(color);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.form?.currentValue) {
      this.formGroup?.patchValue(this.elementSelected);
      this.color = this.elementSelected?.config?.color || this.defaultColor;
    }
  }

  openModalConfigCss() {
    const dialogRef = this.dialog.open(ModalCssComponent, {
      height: '650px',
      width: '700px',
      data: { data: this.formGroup.get(['config','advanced_css']).value },
    });
    dialogRef.afterClosed().subscribe(({ close, css }) => {
      if (close) {
        this.formGroup.get('config')['controls'].advanced_css.setValue(css);
      }
    });
  }

 openModalLoadImage() {
    const dialogRef = this.dialog.open(ModalHeaderComponent, {
      height: '650px',
      width: '80vw',
      data: {
        data: this.formGroup.get(['config','header']).value || '',
        formId: this.formSelected?.sk,
        versionId: this.elementSelected?.pk === 'version' ? this.versionSelected?.sk : this.formSelected?.sk
      },
    });
    dialogRef.afterClosed().subscribe(({ close, header }) => {
      if (close) {
        this.formGroup.get('config')['controls'].header.setValue(header);

      }
    });
  }

  onKeyPress(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;
    // Check if the pressed key is a letter
    if (!/^[a-zA-Z0-9_-]+$/.test(event.key)) {
      event.preventDefault(); // Prevent input of non-letter characters
    }
  }

  moveUp(index: number) {
    if (index === 0) return;
    this.swap(index, index - 1);
  }

  moveDown(index: number) {
    if (index === this.orderableProperties.length - 1) return;
    this.swap(index, index + 1);
  }

  swap(i: number, j: number) {
    const arr = this.orderableProperties;
    const a = arr.at(i);
    const b = arr.at(j);

    arr.setControl(i, b);
    arr.setControl(j, a);

    this.updateOrderIndexes();
  }

  updateOrderIndexes() {
    this.orderableProperties.controls.forEach((ctrl, i) => {
      ctrl.get('order')?.setValue(i);
    });
  }

  resetOrderableProperties(data?: any[]) {
    this.orderableProperties.clear();

    const source = data?.length
      ? [...data] // ✅ clone NgRx / API array
      : this.orderable_properties.map(p => ({
          key: p.key,
          enabled: true,
          order: p.order
        }));

    source
      .slice()
      .sort((a, b) => a.order - b.order)
      .forEach((item, index) => {
        const label =
          this.orderable_properties.find(p => p.key === item.key)?.label
          ?? item.key;

        this.orderableProperties.push(
          this.formBuilder.group({
            key: [item.key],
            label: [label],        // ✅ restored
            enabled: [item.enabled ?? true],
            order: [index],
          })
        );
      });
  }

  dropOrder(event: CdkDragDrop<AbstractControl[]>) {
    if (!this.editActive && !this.isNewForm) return;
    if (event.previousIndex === event.currentIndex) return;

    moveItemInArray(
      this.orderableProperties.controls,
      event.previousIndex,
      event.currentIndex
    );

    this.updateOrderIndexes();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
